// extracted by mini-css-extract-plugin
export default {"flag":"CountryFlag_flag__ohhAW","size-XL":"CountryFlag_size-XL__uUoN1","size-L":"CountryFlag_size-L__xt2tf","size-M":"CountryFlag_size-M__QRosa","size-S":"CountryFlag_size-S__Vn95m"};